import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { MatIconButton, MatButton } from '@angular/material/button';
import { AriaLabelDirective } from 'src/app/shared/directives';
import { MatIcon } from '@angular/material/icon';
import { ADPComponentsModule } from 'digital-core';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { NgClass, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-device-selection-dialog',
    templateUrl: './device-selection-dialog.component.html',
    styleUrls: ['./device-selection-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ModalWindowComponent,
        MatIconButton,
        AriaLabelDirective,
        MatDialogClose,
        MatIcon,
        ADPComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        MatRadioGroup,
        NgClass,
        NgTemplateOutlet,
        MatRadioButton,
        MatButton,
    ]
})
export class DeviceSelectionDialogComponent {
  deviceForm: FormGroup;
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DeviceSelectionDialogComponent>);
  private fb = inject(FormBuilder);

  constructor() {
    this.dialogRef.disableClose = false;
    this.deviceForm = this.fb.group({
      deviceType: ['', Validators.required],
    });
  }

  onContinue(): void {
    if (this.deviceForm.valid) {
      this.dialogRef.close(this.deviceForm.value.deviceType);
    }
  }
}
